import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'serialNumber',
      type: 'default',
      label: '资源编号'
    },
    {
      field: 'peerStatus',
      type: 'select',
      label: '同行或成交',
      placeholder: '请选择同行或成交',
      options: [
        { title: '-请选择-', value: '0' },
        { title: '被标同行', value: '1' },
        { title: '已成交', value: '2' },
        { title: '炸群', value: '3' },
        { title: '违反信用规定', value: '4' },
        { title: '退费客户', value: '5' },
        { title: '高风险客户', value: '6' },
        { title: '分公司', value: '7' },
        { title: '非精准禁开发', value: '8' }
      ]
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
